"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = void 0;
exports.noop = function () { };
//# sourceMappingURL=noop.js.map